<template>
  <div class="chuKuZuoyeWarp">
    <el-tabs v-model="activeName" type="card" style="margin-left:10px;">
      <el-tab-pane label="应付明细" name="one" style="">
        <div ref="searchBox" class="searchBox">
          <!-- 查询条件 -->
          <div>
            <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
              <el-form-item label="运单号:" class="item1">
                <el-input placeholder="" type="textarea" v-model="searchFrom.wayNos" class="gjh" style="width: 150px;"></el-input>
              </el-form-item>
              <el-form-item label="创建时间:">
                <el-date-picker
                  v-model="createTimes"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="签收时间:">
                <el-date-picker
                  v-model="actualSignings"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="结算状态:">
                <el-select size="mini" v-model="searchFrom.yfSettlementStates" placeholder="请选择结算状态">
                  <el-option v-for="item in yfSettlementList" :label="item.showName" :key="item.value"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开票状态:">
                <el-select size="mini" v-model="searchFrom.yfInvoicingStates" placeholder="请选择开票状态">
                  <el-option v-for="item in yfInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="运单号:" prop="wayNo">
                <el-input v-model="searchFrom.wayNo" size="mini" placeholder="请输入运单号"></el-input>
              </el-form-item> -->
              <el-form-item label="承运方:" prop="payer">
                <el-input v-model="searchFrom.payer" size="mini" placeholder="请输入承运方"></el-input>
              </el-form-item>
              <el-form-item label="结算方:" prop="payee">
                <el-input v-model="searchFrom.payee" size="mini" placeholder="请输入结算方"></el-input>
              </el-form-item>
              <!-- <el-form-item label="货物类型:">
                <el-select size="mini" v-model="searchFrom.productTypeName" placeholder="请选择货物类型"
                  style="width:175px">
                  <el-option v-for="item in HWlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item> -->
              <div style="">
                <el-form-item>
                  <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
                  <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
                  <el-button type="primary" size="mini" @click="daochuFN">导出</el-button>
                </el-form-item>
                <span>
                  <el-form-item>
                    <p class="margin0">应付合计：<span class="red">{{map.freightTaxTotalSum}}</span>元</p>
                  </el-form-item>
                </span>
              </div>
            </el-form>
          </div>
        </div>
        <!--表格1-->
        <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
          <el-table :data="tableList" ref="tabref" class="elTab" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
          >
            <!-- <el-table-column type="selection" width="50"></el-table-column> -->
            <el-table-column type="index" width="55" label="序号"></el-table-column>
            <el-table-column prop="wayNo" label="运单号" align="center" width="230"></el-table-column>
            <el-table-column prop="expenditurePatternName" label="支出方式" align="center" width="90" :formatter="formatterRowEmpty">
              <!-- <template scope="scope">
                <span v-show="scope.row.expenditurePattern == '0'">月结</span>
                <span v-show="scope.row.expenditurePattern == '1'">现结</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="" label="结算状态" align="center" width="100">
              <template scope="scope">
                <span class="wsStyle" v-show="scope.row.yfSettlementStates == '-1'">未对账</span>
                <span class="wsStyle" v-show="scope.row.yfSettlementStates == '0'">未付款</span>
                <span class="bfStyle" v-show="scope.row.yfSettlementStates == '1'">部分付款</span>
                <span class="ysStyle" v-show="scope.row.yfSettlementStates == '2'">已付款</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="开票状态" align="center" width="100" :formatter="formatterRowEmpty">
              <template scope="scope">
                <!-- 0.未开票、1.部分开票、2.已开票 -->
                <span class="wsStyle" v-show="scope.row.yfInvoicingStates == '0'">待申请</span>
                <span class="bfStyle" v-show="scope.row.yfInvoicingStates == '11'">待开票</span>
                <span class="bfStyle" v-show="scope.row.yfInvoicingStates == '1'">部分开票</span>
                <span class="ysStyle" v-show="scope.row.yfInvoicingStates == '2'">已开票</span>
                <span v-show="scope.row.yfInvoicingStates===null">-</span>
              </template>
            </el-table-column>
            <el-table-column prop="productTypeName" label="货物类型" align="center" width="120">
            </el-table-column>
            <el-table-column prop="payee" label="结算方" align="center" width="250" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="liquidatedAmountName" label="结算量" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="freightPricingTypeName" label="运费计价" align="center" width="120" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column prop="" label="运费单价" align="center" width="120">
              <template scope="scope">
                <div>
                  <span v-if="scope.row.freightPricingType == '0'">{{scope.row.freightUnitPrice}}元/吨</span>
                  <span v-if="scope.row.freightPricingType == '1'">
                    <span v-if="scope.row.freightUnitPrice != 0">{{scope.row.freightUnitPrice}}元/车</span>
                    <span v-else>-</span>
                  </span>
                  <span v-if="scope.row.freightPricingType == '2'">{{scope.row.freightUnitPrice}}元/方</span>
                  <span v-if="scope.row.freightPricingType == '3'">{{scope.row.freightUnitPrice}}元/件</span>
                  <span v-if="scope.row.freightPricingType == '' || scope.row.freightPricingType == null">-</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="freightAmount" label="运费金额(元)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="disburseSurcharge" label="附加费(元)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="freightTaxTotal" label="应付金额(元)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="yfPaymentAmount" label="已付款金额(元)" align="center" width="130" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="yfNoPaymentAmount" label="未付款金额(元)" align="center" width="130" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="yfInvoiceAmount" label="已开票金额(元)" align="center" width="130" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="yfNoInvoiceAmount" label="未开票金额(元)" align="center" width="130" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="payer" label="承运方" align="center" width="250" :formatter="formatterRowEmpty" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="plateNumber" label="车牌号" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="driverName" label="司机姓名" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="driverPhone" label="司机电话" align="center" width="130" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="orderNo" label="订单号" align="center" width="240" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="yfInvoiceOn" label="发票号" align="center" width="200" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column property="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
            <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
          </el-table>
        </div>
        <!--分页-->
        <div class="pags" style="text-align: left;">
          <el-pagination
            background
            @current-change="handleCurrentChangeA"
            :current-page="searchFrom.pageNo"
            :page-size="searchFrom.pageSize"
            :page-sizes="[10, 20, 30, 40,50]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChangeA"
            :total="total"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { findWayBusinessList, getDictionaryDetailList, findWayBusinessListTotal } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'Freight',
  components: {
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      activeName: 'one',
      dateTimeFormat: dateTimeFormat,
      loading: false,
      yfSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未对账',
          value: '-1'
        },
        {
          showName: '未付款',
          value: '0'
        },
        {
          showName: '部分付款',
          value: '1'
        },
        {
          showName: '已付款',
          value: '2'
        }
      ],
      yfInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '待申请',
          value: '0'
        },
        {
          showName: '待开票',
          value: '11'
        },
        {
          showName: '部分开票',
          value: '1'
        },
        {
          showName: '已开票',
          value: '2'
        }
      ],
      HWlist: [],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTimes: [],
      actualSignings: [],
      searchFrom: {
        payerType: '1',
        yfSettlementStates: '',
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayNos: ''
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['006P00GB001', '006P00GB002'],
      tableList: [],
      map: {
        freightTaxTotalSum: 0
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/freight')
    this.getList()
    // getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    this.createTimes = getLastMonth()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 150 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      this.searchFrom.createTimeStart = this.createTimes[0]
      this.searchFrom.createTimeEnd = this.createTimes[1]
      this.searchFrom.actualSigningTimeStart = this.actualSignings[0]
      this.searchFrom.actualSigningTimeEnd = this.actualSignings[1]
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNos = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNos.split(',')
      } else {
        this.searchFrom.wayNos = ''
        this.searchFrom.wayNoList = null
      }
      findWayBusinessList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      findWayBusinessListTotal(this.searchFrom).then(res => {
        this.map = res
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        payerType: '1',
        yfSettlementStates: '',
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayNos: '',
        wayNoList: null
      }
      // this.createTimes = []
      this.createTimes = getLastMonth()
      this.actualSignings = []
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pagesize = val
      this.getList()
    },
    // 导出
    daochuFN () {
      this.searchFrom.createTimeStart = this.createTimes[0]
      this.searchFrom.createTimeEnd = this.createTimes[1]
      this.searchFrom.actualSigningTimeStart = this.actualSignings[0]
      this.searchFrom.actualSigningTimeEnd = this.actualSignings[1]
      delete this.searchFrom.pageNo
      delete this.searchFrom.pageSize
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNos = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNos.split(',')
      } else {
        this.searchFrom.wayNos = ''
        this.searchFrom.wayNoList = null
      }
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportOutsideYfWayListForHz',
        this.searchFrom,
        '应付明细列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  background-color: #0c46a2 !important;
  color: #fff;
}
/deep/.el-range-editor--mini.el-input__inner {
  height: 28px;
  width: 410px !important;
}
/deep/.el-form{
  width: 100%;
}
/deep/.searchBox .el-input--mini .el-input__inner{
  width: 150px !important;
}
</style>
